import React, { Component } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";

import { showErrorToast } from "../../../../components";
import {
  AgentService,
  MaterialService,
  OrderService,
  TagService,
} from "../../../../services";
import NewOrderLayout from "../../../shared/order/new-order-layout";
import { agentType, agentTypeERP } from "../../../../constants/order";
import { STATUS_AGENT } from "../../../../constants/agent/status";

class CompanyNewOrderPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      agentList: {
        loading: false,
        list: [],
      },
      // isAllMaterial: false,
      // notIncludeMaterials: [],
      isAllAgents: false,
      notIncludeAgents: [],
      agentSelectedList: [],
      materialList: {
        loading: false,
        list: [],
      },
      tagBusinessUnityList: {
        loading: false,
        list: [],
        total: 0,
      },
      newOrder: {
        data: {},
        loading: false,
        newOrderApproved: false,
        newOrderCreated: false,
      },
    };
  }

  componentDidMount() {
    const commomParams = {
      skip: 0,
      take: 24,
    };
    const materialsParams = {
      ...commomParams,
      orderBy: { attribute: "quantity", value: "DESC" },
    };
    const agentsParams = {
      ...commomParams,
      take: 10000,
      filters: { standard: [], status: STATUS_AGENT.ACTIVE },
      orderBy: { attribute: "name", value: "ASC" },
    };
    const buParams = {
      commomParams,
      type: 1,
    };

    this._requestTagBusinessUnityList(buParams);
    this._requestAgentList(agentsParams);
    this._requestMaterialList(materialsParams);
  }

  _requestTagBusinessUnityList = async (data) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ tagBusinessUnityList }) => ({
        tagBusinessUnityList: {
          ...tagBusinessUnityList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await TagService.fetchTagList(data);

      this.setState(({ tagBusinessUnityList }) => ({
        tagBusinessUnityList: {
          ...tagBusinessUnityList,
          loading: false,
          list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ tagBusinessUnityList }) => ({
        tagBusinessUnityList: {
          ...tagBusinessUnityList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestAgentList = async (data, increase) => {
    const { dispatch } = this.props;
    const request = data;

    if (
      data.filters &&
      (data.filters.standard.length > 0 || data.filters.tagName)
    ) {
      if (
        data.filters.standard[0] &&
        data.filters.standard[0].attribute === agentType.CATEGORIE
      ) {
        request.filters.tagsId = data.filters.standard[0].value;
        request.filters.standard = [];
      }

      if (
        data.filters.standard[0] &&
        data.filters.standard[0].attribute === agentTypeERP.TAXNUMBER_OR_ERP
      ) {
        request.filters.taxnumberOrERP = data.filters.standard[0].value;
        request.filters.standard = [];
      }

      if (data.filters.tagsId) {
        request.filters.tagsId = data.filters.tagsId;
        request.filters.standard = [];
      }

      if (data.filters.taxnumberOrERP) {
        request.filters.taxnumberOrERP = data.filters.taxnumberOrERP;
        request.filters.standard = [];
      }
    }

    try {
      this.setState(({ agentList, agentSelectedList }) => ({
        ...agentSelectedList,
        agentList: {
          ...agentList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await AgentService.fetchAgentList(request);

      this.setState(({ agentSelectedList, agentList }) => ({
        ...agentSelectedList,
        agentList: {
          ...agentList,
          loading: false,
          list: increase ? [...agentList.list, ...list] : list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ agentSelectedList, agentList }) => ({
        ...agentSelectedList,
        agentList: {
          ...agentList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _requestMaterialList = async (data, increase) => {
    const { dispatch } = this.props;

    try {
      this.setState(({ materialList }) => ({
        materialList: {
          ...materialList,
          loading: true,
        },
      }));

      const {
        data: { list, total },
      } = await MaterialService.fetchMaterialList({
        ...data,
        noImages: true,
      });

      this.setState(({ materialList }) => ({
        materialList: {
          ...materialList,
          loading: false,
          list: increase ? [...materialList.list, ...list] : list,
          total,
        },
      }));
    } catch (e) {
      this.setState(({ materialList }) => ({
        materialList: {
          ...materialList,
          loading: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _handleNewOrderSubmit = async (values) => {
    this.setState(({ newOrder }) => ({
      newOrder: {
        ...newOrder,
        data: values,
        newOrderApproved: false,
        newOrderCreated: false,
      },
    }));
  };

  _requestNewAndApproveOrder = async (approved) => {
    const { dispatch } = this.props;
    const { data } = this.state.newOrder;
    try {
      this.setState(({ newOrder }) => ({
        newOrder: {
          ...newOrder,
          loading: true,
          newOrderApproved: false,
          newOrderCreated: false,
        },
      }));

      Object.assign(data, { approveOrder: approved });
      await OrderService.createOrder(data);
      this.setState(({ newOrder }) => ({
        newOrder: {
          ...newOrder,
          loading: false,
          newOrderApproved: approved,
          newOrderCreated: true,
        },
      }));
    } catch (e) {
      this.setState(({ newOrder }) => ({
        newOrder: {
          ...newOrder,
          loading: false,
          newOrderApproved: false,
          newOrderCreated: false,
        },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  _getValidations = () =>
    Yup.object().shape({
      promotionalCicleName: Yup.string().matches(
        /^[a-zA-Z0-9_]*$/i,
        "Não utilize símbolos ou espaços. Ex.: ABC123",
        { excludeEmptyString: true }
      ),
    });

  _onChangeAgentSelectedList = (newAgentsSelected) => {
    this.setState({
      agentSelectedList: newAgentsSelected,
    });
  };

  _handleOnChangeIsAllMaterial = (isAllMaterial) => {
    this.setState({
      isAllMaterial,
    });
  };

  _handleOnChangeIsAllAgents = (isAllAgents) => {
    this.setState({
      isAllAgents,
    });
  };

  _handleOnChangeNotIncludeMaterials = (notIncludeMaterials) => {
    this.setState({
      notIncludeMaterials,
    });
  };

  _handleOnChangeNotIncludeAgents = (notIncludeAgents) => {
    this.setState({
      notIncludeAgents,
    });
  };

  render() {
    const { userData } = this.props;

    const {
      loading,
      agentList,
      materialList,
      agentSelectedList = [],
      newOrder,
      tagBusinessUnityList,
    } = this.state;

    return (
      <NewOrderLayout
        title="Novo pedido"
        userData={userData}
        loading={loading}
        agentList={agentList}
        materialList={materialList}
        tagBusinessUnityList={tagBusinessUnityList}
        agentSelectedList={agentSelectedList}
        onChangeAgentSelectedList={this._onChangeAgentSelectedList}
        onRequestAgentList={this._requestAgentList}
        onRequestMaterialList={this._requestMaterialList}
        handleValidations={this._getValidations}
        handleNewOrderSubmit={this._handleNewOrderSubmit}
        handleConfirmDialog={this._requestNewAndApproveOrder}
        loadingDialog={newOrder.loading}
        newOrderApproved={newOrder.newOrderApproved}
        newOrderCreated={newOrder.newOrderCreated}
        handleOnChangeIsAllMaterial={this._handleOnChangeIsAllMaterial}
        handleOnChangeIsAllAgents={this._handleOnChangeIsAllAgents}
        handleOnChangeNotIncludeMaterials={
          this._handleOnChangeNotIncludeMaterials
        }
        handleOnChangeNotIncludeAgents={this._handleOnChangeNotIncludeAgents}
        commomParams={{
          skip: 0,
          take: 10,
        }}
      />
    );
  }
}

const mapStateToProps = (data) => data;

export default connect(mapStateToProps)(CompanyNewOrderPage);
